import { Fragment, useContext } from 'react';
import FeatureBranch from '@/common/FeatureBranch';
import PageFooter from '@/common/PageFooter';
import SectionTypes from '~/constants/sem/SectionTypes';
import StaticContext from '~/context/sem/StaticContext';
import ActionBanners from './ActionBanners';
import Hero from './Hero';
import Inventory from './Inventory';
import PageHeader from './PageHeader';
import PopularModels from './PopularModels';
import PopularSearches from './PopularSearches';
import ShopByFeature from './ShopByFeature';
import ShopByMake from './ShopByMake';
import StickyBanner from './StickyBanner';
import WhyCarvana from './WhyCarvana';

const SECTION_MAPPING = {
  [SectionTypes.SemBrandMarketingModule]: WhyCarvana,
  [SectionTypes.SemHeroModule]: Hero,
  [SectionTypes.SemInventoryModule]: Inventory,
  [SectionTypes.SemOpenListModule]: ShopByMake,
  [SectionTypes.SemPanelListModule]: PopularSearches,
  [SectionTypes.SemSearchTilesModule]: PopularModels,
  [SectionTypes.SemVehicleFeatureGridModule]: ShopByFeature,
  [SectionTypes.SemActionBannerModule]: ActionBanners
};

export default function SemContainer() {
  const {
    pageContent: { modules },
    semModularRequest
  } = useContext(StaticContext);

  return (
    <>
      <FeatureBranch appName="homepage" className="max-w-[1440px]" />
      <main className="relative mx-auto max-w-[1440px] bg-white">
        <PageHeader />
        {modules.map(({ __typename, id, ...rest }, index) => {
          const Component = SECTION_MAPPING[__typename];

          return Component ? (
            <Fragment key={id ?? __typename}>
              {index === 0 && <StickyBanner />}
              <Component
                id={id ?? __typename}
                {...rest}
                semModularRequest={semModularRequest}
              />
            </Fragment>
          ) : null;
        })}
      </main>
      <div className="mx-auto max-w-[1440px]">
        <PageFooter />
      </div>
    </>
  );
}
